import "./index.scss";

import { Box, Grid } from "@mui/material";
import { memo, useEffect, useMemo, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";

import WorkoutSearchableList from "../WorkoutSearchableList";

const WorkoutPlanFlexibility = ({ upperBodyStretchesOptions, lowerBodyStretchesOptions }) => {
  const formContext = useFormContext();
  const {
    setValue,
    getValues,
    formState: { errors },
  } = formContext;
  const [optionsUpperBodyStretches, setOptionsUpperBodyStretches] =
    useState(upperBodyStretchesOptions);
  const [optionsLowerBodyStretches, setOptionsLowerBodyStretches] =
    useState(lowerBodyStretchesOptions);
  const [stretchExercises, setStretchExercises] = useState(getValues("stretch_exercises"));

  useEffect(() => {
    setValue("stretch_exercises", stretchExercises);
  }, [setValue, stretchExercises]);

  //#region event handlers
  const handleStretchExercisesUpdate = (selectedValues, subListOfOptions) => {
    let stretchExercisesCopy = [...stretchExercises];
    const selectedValuesIds = selectedValues.map((e) => e.id);
    const subListOfOptionsIds = subListOfOptions.map((e) => e.id);
    const subListOfOptionsFlagged = subListOfOptionsIds.map((e) => {
      return { id: e, isSelected: selectedValuesIds.includes(e) };
    });
    subListOfOptionsFlagged.forEach((e, index) => {
      //If the exercise was selected and is no longer, remove it
      if (stretchExercisesCopy.includes(e.id) && !e.isSelected) {
        const indexOfEntry = stretchExercisesCopy.findIndex((entry) => entry === e.id);
        stretchExercisesCopy.splice(indexOfEntry, 1);
      }
      if (!stretchExercisesCopy.includes(e.id) && e.isSelected) {
        stretchExercisesCopy.push(e.id);
      }
    });
    setStretchExercises(stretchExercisesCopy);
  };
  //#endregion event handlers

  const countUpperSelectedItems = useMemo(() => {
    return (
      optionsUpperBodyStretches
        ?.map((item) => item.id)
        ?.filter((id) => stretchExercises.includes(id))?.length || 0
    );
  }, [optionsUpperBodyStretches, stretchExercises]);

  const countLowerSelectedItems = useMemo(() => {
    return (
      optionsLowerBodyStretches
        ?.map((item) => item.id)
        ?.filter((id) => stretchExercises.includes(id))?.length || 0
    );
  }, [optionsLowerBodyStretches, stretchExercises]);

  return (
    <Grid container spacing={5} mb={8} className="workoutPlanFlexibility">
      <Grid item xs={6}>
        <Box className="search-list">
          <h2 className="headerSpacing">Upper Body Stretches</h2>
          <WorkoutSearchableList
            options={optionsUpperBodyStretches}
            selectedEntries={stretchExercises}
            callback={(v) => handleStretchExercisesUpdate(v, optionsUpperBodyStretches)}
          />
          <span className="selectedGoalsSummary">{countUpperSelectedItems} items selected</span>
        </Box>
      </Grid>
      <Grid item xs={6}>
        <Box className="search-list">
          <h2 className="headerSpacing">Lower Body Stretches</h2>
          <WorkoutSearchableList
            options={optionsLowerBodyStretches}
            selectedEntries={stretchExercises}
            callback={(v) => handleStretchExercisesUpdate(v, optionsLowerBodyStretches)}
          />
          <span className="selectedGoalsSummary">{countLowerSelectedItems} items selected</span>
        </Box>
      </Grid>
    </Grid>
  );
};

export default memo(WorkoutPlanFlexibility);
